import { Col, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import React from 'react';
import {
  Fixed2,
  TableParams,
  pagination,
} from '../../../../common/utils/common.utils';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import FormHeaderTitle from '../../../Invoice(Visa)/Components/FormHeaderTitle';
import { useTodaySalesReportQuery } from '../endpoints/totalCollectionPayments';
import {
  ITodaySalesReportCollection,
  ITodaySalesReportSales,
} from '../types/totalCollectionTypes';
import CommonViewReport from '../../../../components/common/Invoice/ViewInvoiceInfo/CommonViewReport';

type Props = {
  value: 'sales&collection' | 'sales&payments';
  refSales: React.MutableRefObject<null>;
  refPayment: React.MutableRefObject<null>;
};

export default function SalesAndCollectionTables({
  value,
  refPayment,
  refSales,
}: Props) {
  const { data, isLoading, isError, refetch } = useTodaySalesReportQuery(
    undefined,
    {
      selectFromResult: (cache) => {
        const data = cache.data?.data;
        const collection: ITodaySalesReportCollection[] = [];
        const sales: ITodaySalesReportSales[] = [];
        if (data?.collection) {
          for (let i = 0; i < data.collection.length; i++) {
            const element = data.collection[i];
            collection.push({
              ...element,
              key: i + 1,
            });
          }
        }
        if (data?.sales) {
          for (let i = 0; i < data.sales.length; i++) {
            const element = data.sales[i];
            sales.push({
              ...element,
              key: i + 1,
            });
          }
        }
        return { ...cache, data: { collection, sales } };
      },
    }
  );

  const [tableParams, setTableParams] = React.useState<TableParams>({
    pagination: {
      current: 1,
      defaultPageSize: 50,
      showSizeChanger: true,
      pageSizeOptions: ['50', '100', '200', '500'],
      pageSize: 20,
      total: data?.sales.length,
    },
  });

  const column: ColumnsType<ITodaySalesReportSales> = [
    {
      title: 'SL.',
      render: (_, data, index) => (
        <>
          {((tableParams?.pagination?.current || 1) - 1) *
            (tableParams?.pagination?.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },

    {
      title: 'Sales Date',
      dataIndex: 'sales_date',
      render(value, record, index) {
        return (
          <>
            {record?.sales_date
              ? dayjs(record?.sales_date).format('DD-MM-YYYY')
              : ''}
          </>
        );
      },
    },
    {
      title: 'Invoice No',
      dataIndex: 'invoice_no',
      key: 'invoice_no',
    },

    {
      title: 'Client',
      dataIndex: 'client_name',
      key: 'client_name',
    },

    {
      title: 'Sales Amount',
      dataIndex: 'sales_price',
      key: 'sales_price',
      align: 'right',
      render(value, record, index) {
        return <>{Number(value)}</>;
      },
    },
  ];

  const [tableParams1, setTableParams1] = React.useState<TableParams>({
    pagination: {
      current: 1,
      defaultPageSize: 50,
      showSizeChanger: true,
      pageSizeOptions: ['50', '100', '200', '500'],
      pageSize: 20,
      total: data?.collection.length,
    },
  });
  const columnPayments: ColumnsType<ITodaySalesReportCollection> = [
    {
      title: 'SL.',
      render: (_, data, index) => (
        <>
          {((tableParams1?.pagination?.current || 1) - 1) *
            (tableParams1?.pagination?.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },

    {
      title: 'Collection Date',
      dataIndex: 'receipt_payment_date',
      render(value, record, index) {
        return (
          <>
            {record?.receipt_payment_date
              ? dayjs(record?.receipt_payment_date).format('DD-MM-YYYY')
              : ''}
          </>
        );
      },
    },
    {
      title: 'Vouchar No',
      dataIndex: 'receipt_vouchar_no',
      key: 'receipt_vouchar_no',
    },

    {
      title: 'Client',
      dataIndex: 'client_name',
      key: 'client_name',
    },

    {
      title: 'Collected Amount',
      dataIndex: 'receipt_total_amount',
      key: 'receipt_total_amount',
      align: 'right',
      render(value, record, index) {
        return <>{Number(value)}</>;
      },
    },
  ];

  React.useEffect(() => {
    refetch();
  }, [value]);

  // @HANDLE CONTENTS
  const jsx_com = (
    <Table
      size='small'
      bordered
      columns={column}
      loading={{ spinning: isLoading, indicator: loadingIndicator }}
      dataSource={data?.sales}
      // scroll={{ x: true }}
      summary={(_) => {
        return (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={4} index={1}>
              <Col push={8}>
                <Typography.Text strong>Total:</Typography.Text>
              </Col>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2}>
              <div
                style={{
                  color: 'green',
                  fontWeight: '700',
                  textAlign: 'right',
                }}
              >
                <Typography.Text style={{ fontWeight: 'bolder' }}>
                  {Fixed2(
                    data?.sales?.reduce(
                      (a, b) => a + Number(b?.sales_price || 0),
                      0
                    ) || 0
                  )}
                </Typography.Text>
              </div>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        );
      }}
      pagination={pagination(data?.sales.length)}
      onChange={(args1) => {
        setTableParams((prev) => ({ ...prev, pagination: args1 }));
      }}
    />
  );
  const jsx_com1 = (
    <Table
      size='small'
      bordered
      columns={columnPayments}
      loading={{ spinning: isLoading, indicator: loadingIndicator }}
      dataSource={data?.collection}
      summary={(_) => {
        return (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={4} index={1}>
              <Col push={8}>
                <Typography.Text strong>Total :</Typography.Text>
              </Col>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2}>
              <div
                style={{
                  color: 'green',
                  fontWeight: '700',
                  textAlign: 'right',
                }}
              >
                <Typography.Text style={{ fontWeight: 'bolder' }}>
                  {Fixed2(
                    _?.reduce(
                      (a, b) => a + Number(b?.receipt_total_amount || 0),
                      0
                    ) || 0
                  )}
                </Typography.Text>
              </div>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        );
      }}
      pagination={pagination(data?.collection.length)}
      onChange={(args1) => {
        setTableParams1((prev) => ({ ...prev, pagination: args1 }));
      }}
    />
  );

  // @HANDLE PRINT WITH HEADER FOOTER
  const print_content = (
    <div hidden>
      <CommonViewReport
        children={jsx_com}
        printRef={refSales}
        title={{ info_title: '', title: 'Daily Sales' }}
      />
    </div>
  );
  const print_content1 = (
    <div hidden>
      <CommonViewReport
        children={jsx_com1}
        printRef={refPayment}
        title={{ info_title: '', title: 'Daily Collection' }}
      />
    </div>
  );

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      {/* Sales */}
      <div style={{ flexGrow: '1' }}>
        <FormHeaderTitle title='Sales' />

        {jsx_com}
      </div>

      {/* Collection */}
      <div ref={refPayment} style={{ flexGrow: '1' }}>
        <FormHeaderTitle title='Collection' />
        {jsx_com1}
      </div>

      {/* Sales Print */}
      {print_content}

      {/* Collection Print */}
      {print_content1}
    </div>
  );
}
